import React, { useState } from "react";
import "./index.scss";
import { showSuccessToaster } from "../toaster/success";
import { showErrorToaster } from "../toaster/error";
import CandidatureService from "../../services/candidature/condidature.service";
const candidatureService = new CandidatureService();

const Modal = ({ showModal, handleClose, missionId }) => {
  const [formData, setFormData] = useState({
    fullname: "",
    email: "",
    phone: "",
    missionId: missionId,
    lettreMotivation: "",
  });

  const [cvFile, setCvFile] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    console.log('Fichier sélectionné:', file);  // Debug pour voir le fichier
    if (file) {
      setCvFile(file); // Sauvegarder le fichier dans l'état
    }
  };

  const handleSubmit = async () => {
    if (!cvFile) {
      console.log("Aucun fichier sélectionné");
      showErrorToaster("Veuillez sélectionner un fichier.");
      return;
    }

    // Création d'un FormData
    const formDataToSend = new FormData();
    formDataToSend.append("fullname", formData.fullname);
    formDataToSend.append("email", formData.email);
    formDataToSend.append("phone", formData.phone);
    formDataToSend.append("missionId", missionId);
    formDataToSend.append("cv", cvFile);  // Ajouter le fichier au FormData
    formDataToSend.append("lettreMotivation", formData.lettreMotivation);

    console.log('Données à envoyer :');
    for (let pair of formDataToSend.entries()) {
      console.log(pair[0] + ': ' + pair[1]);  // Afficher le contenu de FormData pour débogage
    }

    try {
      const response = await candidatureService.addCandidature(formDataToSend);

      if (response.status === 201) {
        // Réinitialisation du formulaire
        setFormData({
          fullname: "",
          email: "",
          phone: "",
          missionId: missionId,
          lettreMotivation: "",
        });
        setCvFile(null); // Réinitialiser le fichier
        handleClose();
        showSuccessToaster("Candidature soumise avec succès!");
      } else {
        showErrorToaster("Erreur lors de la soumission de la candidature");
      }
    } catch (error) {
      console.error("Erreur réseau:", error);
      showErrorToaster("Erreur lors de la soumission de la candidature");
    }
  };

  if (!showModal) return null;

  return (
    <div className="modal-overlay-mission">
      <div className="modal-content-mission">
        <button className="close-button-mission" onClick={handleClose}>
          X
        </button>
        <h2>Formulaire de Candidature</h2>
        <div className="form-mission">
          <div className="form-group-mission">
            <label htmlFor="fullname">Nom Complet</label>
            <input
              type="text"
              id="fullname"
              name="fullname"
              value={formData.fullname}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group-mission">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group-mission">
            <label htmlFor="phone">Téléphone</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group-mission">
            <label htmlFor="cv">CV (PDF)</label>
            <input
              type="file"
              id="cv"
              name="cv"
              accept=".pdf"
              onChange={handleFileChange}
              required
            />
          </div>

          <div className="form-group-mission">
            <label htmlFor="lettreMotivation">Lettre de Motivation</label>
            <textarea
              id="lettreMotivation"
              name="lettreMotivation"
              value={formData.lettreMotivation}
              onChange={handleChange}
              required
            />
          </div>

          <button onClick={handleSubmit} className="submit-button-mission">
            Soumettre
          </button>
        </div>
      </div>
    </div>
  );
};

export default Modal;
